module.exports = __webpack_public_path__ + "img/hrm-katherine.9a78ccf.png";